import MUILink, { LinkProps as MUILinkProps } from '@material-ui/core/Link';
import NextJSLink, { LinkProps } from 'next/link';
import { FC } from 'react';

export { ActiveLink } from './active';
export { ContrastLink } from './contrast';
export { ImperceptibleLink } from './imperceptible';

export type Properties = LinkProps & Pick<MUILinkProps, 'className' | 'target' | 'rel' | 'underline'>;

export const Link: FC<Properties> = ({ children, className, target, rel, underline, ...rest }) => {
  return (
    <NextJSLink passHref {...rest}>
      <MUILink className={className} color="inherit" target={target} rel={rel} underline={underline}>
        {children}
      </MUILink>
    </NextJSLink>
  );
};

export default Link;
